// PROLIFIC_FEEDBACK_DATA
let initialState = {
    feedbackQuestions: [],
    surveyQuestions: [],
    currentProgress: 0,
    progessStepsDetails: {},
}

export default function feedBackSurveyReducer(state = initialState, action) {
    switch (action.type) {
        case 'PROLIFIC_FEEDBACK_QUESTIONS_SUCCESS':
            return {
                ...state,
                feedbackQuestions: action.payload,
                progessStepsDetails: getProgessStepDetails(action.payload)

            }
        case 'GET_PROLIFIC_FEEDBACK_PROGRESS_PERCENT':
            return {
                ...state,
                currentProgress: getCureentProgress(state?.feedbackQuestions?.[0], action.payload)
            }
        case 'RESET_PROLIFIC_FEEDBACK_QUESTIONS':
            return {
                ...state,
                feedbackQuestions: []
            }
        default:
            return state
    }
}

const getProgessStepDetails = (data) => {
    if (data && data.length && data?.[0]?.steps && data?.[0]?.steps?.length) {
        return data?.[0]?.steps?.[0]
    }
}

const calculateStepPercentages = (questionsPerStep, totalSteps) => questionsPerStep.map(questions => (100 / totalSteps) / questions);

const calculateProgress = (currentStepIndex, answersInCurrentStep, stepPercentages, totalSteps) => {
    const completedStepsProgress = currentStepIndex * (100 / totalSteps); // Each completed step contributes 25%
    const currentStepProgress = answersInCurrentStep * stepPercentages[currentStepIndex]; // Progress in the current step
    return completedStepsProgress + currentStepProgress;
};

function getCureentProgress(surveyData, answersInCurrentStep = 0) {
    if (surveyData && surveyData?.steps) {
        let stepsData = surveyData?.steps?.[0]
        let questionsPerStep = stepsData?.per_step_ques
        let totalSteps = stepsData?.total_steps
        let currentStep = stepsData?.current_step
        let stepPercentages = calculateStepPercentages(questionsPerStep, totalSteps)
        let progress = calculateProgress(currentStep, answersInCurrentStep, stepPercentages, totalSteps)
        return progress
    } else {
        return 0
    }

}